<!-- 订单按钮组件 -->
<template>
  <div class="Orderbutton">
    <!--订单金额-->
    <div class="order-amount">
        <div>订单金额：
            <span class="price" v-if="orderDetail.discount_need_arr.price">¥{{orderDetail.price*1 + Math.abs(orderDetail.discount_need_arr.price)}}</span>
            <span class="text-danger fw">¥{{orderDetail.price}}</span>
        </div>
        <template v-if="$GFUN.isInArray([2,99],storeInfo.type)&&orderDetail.price_pay>0">
              <div v-if="orderDetail.broker==0">
                <p>已支付：</p>
                <span class=" fw qls fotn-size-18" :class="orderDetail.price_pay/100>orderDetail.price&&orderDetail.broker>0?'':' text-green'">
                  ¥{{orderDetail.price_pay/100>orderDetail.price&&orderDetail.broker>0?orderDetail.price:orderDetail.price_pay/100}}
                </span>
              </div>
              <div v-else>
                <p> 已收款：</p><span class="text-green fw fotn-size-18">¥{{orderDetail.price_pay/100}}</span>
              </div>
              <div v-if="orderDetail.offset_pay>0"><p>未&ensp;支&ensp;付：</p><span class="red fw fotn-size-18">¥{{orderDetail.offset_pay/100}}</span></div>
        </template>
        <template v-if="storeInfo.type===3&&orderDetail.price_pay>0"> 
            <div ><p>已&ensp;收&ensp;款：</p><span class="text-green fw fotn-size-18">¥{{orderDetail.price_pay/100}}</span></div>
            <div v-if="orderDetail.offset_pay>0"><p>未&ensp;收&ensp;款：</p><span class="red fw fotn-size-18">¥{{orderDetail.offset_pay/100}}</span></div>
        </template>
        <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            >
            <div>
                <ul class="expenseDetails">
                    <li v-if="price.room_price">
                        <p>用房</p>
                        <span>¥{{ price.room_price}}</span>
                    </li>
                    <li v-if="price.meeting_price">
                        <p>会议室</p>
                        <span >¥{{ price.meeting_price}}</span>
                    </li>
                    <li v-if="price.discount_price">
                        <p>优惠房</p>
                        <span class="text-success">¥{{ price.discount_price}}</span>
                    </li>
                    <li v-if="price.add_price">
                        <p>附加需求</p>
                        <span >¥{{ price.add_price}}</span>
                    </li>
                    <li v-if="orderDetail.deposit>0">
                        <p>订金</p>
                        <span >¥{{orderDetail.deposit}}</span>
                    </li>
                </ul>
            </div>
            <el-button class="ml-2" size="mini" slot="reference" icon="el-icon-collection">费用明细</el-button>
            </el-popover>
        <span v-if="$GFUN.isInArray([7,8,9],orderDetail.status)&&storeInfo.type!=3" class="ml-3" >
            <el-button v-if="(orderDetail.price_pay/100)>0"  size="mini" class="bottom" @click="$emit('recordShow')" icon="el-icon-date">支付明细</el-button>    
        </span>
    </div>
     <template v-if="orderDetail.pay_flag_hotel > 0 || orderDetail.pay_flag_travel > 0">
        <div  class="order-bottoms d-flex" v-if="$GFUN.isInArray([2],storeInfo.type)">
            <div class="financials mr-2">订单已提交财务</div>
            <el-button   @click="orderComplete" type="primary" class="bottom" size="small" icon="el-icon-circle-check">完成订单</el-button>
        </div>
        <div  class="order-bottoms d-flex" v-else>
            <div class="financials mr-2">订单已提交财务</div>
            <el-button @click="payOrder(1)" v-if="orderDetail.pay_flag_hotel==1" type="danger" class="bottom" size="small">平台待打款</el-button>
            <el-button @click="payOrder(2)" v-if="orderDetail.pay_flag_hotel==2" type="success" class="bottom" size="small">平台已打款</el-button>
        </div>
     </template>
    <template v-else-if="$GFUN.isInArray([7,8],orderDetail.status)">
        <!--操作按钮-采购商-->
        <div v-if="$GFUN.isInArray([2],storeInfo.type)" class="order-bottoms">
            <!--订单修改待确认-->
            <template v-if="orderDetail.edit_status==1">
                <el-button @click="$emit('viewChanges')" type="success" class="bottom" size="small" icon="el-icon-view">查看修改</el-button>
                <el-button  v-if="orderDetail.edit_launch_uid==userLoginMessage.uid" @click="$emit('collectionShow')"  type="warning" class="bottom" size="small" icon="el-icon-document-copy">代收款</el-button>
            </template>
            <template v-else>
                <el-button @click="$emit('paymentShow')" type="success" class="bottom" size="small" icon="el-icon-bank-card">立即支付</el-button>
                <el-button v-if="orderDetail.deposit==0||orderDetail.deposit_uid==storeInfo.storeId||orderDetail.price_pay>0&&orderDetail.deposit>0" @click="$emit('modifyDepositShow')" type="success" class="bottom" size="small" icon="el-icon-coin">设置订金</el-button>
                <el-button @click="modifyOrder" type="primary" class="bottom" size="small" icon="el-icon-edit">修改订单</el-button>
                <el-button @click="$emit('collectionShow')"  type="warning" class="bottom" size="small" icon="el-icon-document-copy">代收款</el-button>
                <el-button @click="orderComplete" type="primary" class="bottom" size="small" icon="el-icon-circle-check">完成订单</el-button>
                <el-button @click="$emit('showConfirmPanel')" class="bottom" size="small" icon="el-icon-circle-close">取消订单</el-button>
            </template>
        </div>
        <div v-if="$GFUN.isInArray([3],storeInfo.type)" class="order-bottoms">
            <!--订单修改待确认-->
            <template v-if="orderDetail.edit_status==1">
                <el-button @click="$emit('viewChanges')" type="success" class="bottom" size="small" icon="el-icon-view">查看修改</el-button>
            </template>
            <template v-else>
                <el-button v-if="orderDetail.deposit==0||orderDetail.deposit_uid==userLoginMessage.uid||orderDetail.price_pay>0&&orderDetail.deposit>0" @click="$emit('modifyDepositShow')" type="success" class="bottom" size="small" icon="el-icon-coin">设置订金</el-button>
                <el-button @click="modifyOrder" type="primary" class="bottom" size="small" icon="el-icon-edit">修改订单</el-button>
                <el-button v-if="orderDetail.pay_arr.length>0" @click="paymentCollection(orderDetail.oid)" class="bottom" size="small" icon="el-icon-position">发起收款</el-button>
                <el-button @click="$emit('getQRcode')" class="bottom" size="small" icon="el-icon-full-screen">分享二维码</el-button>
            </template>
        </div>
    </template>
    <template v-if="$GFUN.isInArray([5],orderDetail.status)&&$GFUN.isInArray([2,3],storeInfo.type)">
        <el-button @click="modifyOrder" type="success" class="bottom" size="small" icon="el-icon-edit">修改订单</el-button>
        <el-button @click="$emit('showConfirmPanel')" class="bottom" size="small" icon="el-icon-circle-close">取消订单</el-button>
    </template>
  </div>
</template>

<script>

import { mapGetters,mapState,mapActions} from 'vuex'
export default {
  name: 'Orderbutton',
  components: {},
  props: {
    orderDetail: {
        type: Object,
        default: () => {}
    }
  },
  data() {
    return {
        price:{},                        //订单明细
        record:false,                    //支明细弹窗
        dialogFormVisible:false,        //打款回单弹窗
    };
  },
  computed: {
       ...mapGetters(['storeInfo','travelComplete']),
       ...mapState(['userLoginMessage']),
  },
  watch: {
    orderDetail: {
      handler(res, oldVal) {
            //价格值
            this.price.total_price=res.price;
            this.price.room_price=res.room_need_arr.price;
            this.price.meeting_price=res.meeting_need_arr.price;
            this.price.add_price=res.add_need_arr.price;
            this.price.discount_price=res.discount_need_arr.price;
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
     ...mapActions(['hGetOrderTradeList']),
    //完成订单
    orderComplete(){
        this._confirm('确定订单尾款已结清并结束订单么？',async () => {
            this.travelComplete({
                oid:this.orderDetail.oid,
                successFun:()=>{
                    //更新订单
                    this.$emit('getorderDetail')
                }
            })
        })
    },
    //修改订单
    modifyOrder() {
        if(this.orderDetail.edit_status==0||this.orderDetail.status==5){
            let query = {type:this.orderDetail.order_type,orderId:this.orderDetail.oid,modify:true,orderConfirm:true}
            if (this.orderDetail.appoint > 0) query.hotel = this.orderDetail.appoint;
            this.$router.push({name:'OrderPost',query})
        }
    },
          //打开退款弹窗
      records(item){
          console.log(item);
        this.showDetail=true;
        this.refundDetail=item;
      },
      //平台打款提示
      payOrder(type){
        if(type==1){
            this._alert('平台打款处理中，请耐心等待',() => {Router.back()})
        }else{
            this.$emit('receiptShow')
        }
      },
      //酒店用户通知收款
      paymentCollection(e){
        this._confirm('是否通知支付人付款？',() => {
            this.hGetOrderTradeList({
              data:{oid:e},
              successFun: () => {
                this._alert('通知已发送');
              }
            });
        })
      },
        // travelCompl
        // ete({ dispatch, getters,state }) {
        //   _confirm('确定订单尾款已结清并结束订单么？',async () => {
        //     let res = await _axios.post('/pc/Travel/EndOrderHotel', {
        //       store_id: getters.storeInfo.storeId,
        //       oid: state.OrderDetail.oid,
        //     });
        //     if (res.code === '00000') _alert('已完成订单',() => {Router.back()})
        //     //dispatch('GetOrderDetail',state.OrderDetail.oid)
        //   })
        // },
  }
};
</script>

<style lang="scss" scoped>
.Orderbutton{
    background-color: #fff;
    width: 96%;
    position: sticky;
    height: 40px;
    margin-top: 20px;
    padding: 10px 2%;
    bottom:10px;
    left: -0px;
    z-index: 4;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0px 0 12px 0px rgba(97, 105, 119, 0.18);
    border-radius: 4px;
}
.order-amount{
    margin-right: auto;
    line-height: 40px;
    display: flex;
    div{
        display: flex;
        margin-right: 1rem;
    }
}
.fw{
    font-weight: bold;
}
.order-bottoms{
    line-height: 40px;
}
  .expenseDetails{
    width: 100%;
    li{
      border-bottom: 1px #eee solid;
      padding: 12px 0;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #333;
    }
    li:last-child{
      border-bottom: none;
    }
  }
  .financials{
        font-size: 12px;
        line-height: 84rpx;
        color: var(--smtc-color-green);
    }
  .price{
          color: var(--smtc-color-text-shallow);
          text-decoration: line-through;
          margin-right: 6px;
          font-weight: normal;
          font-size: 12px;
  }
</style>
